import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  resetOnboarding,
  triggerTestError,
  updateDevSettings,
  type UpdateDevSettingsRequest,
} from '@/requests/dev-settings/dev-settings.requests'

export function useUpdateDevSettingsMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UpdateDevSettingsRequest) => updateDevSettings(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['dev-settings'] })
    },
  })
}

export function useTriggerTestErrorMutation() {
  return useMutation({
    mutationFn: () => triggerTestError(),
  })
}

export function useResetOnboardingMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => resetOnboarding(),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['organization'] }),
        queryClient.invalidateQueries({ queryKey: ['onboarding-status'] }),
      ])
    },
  })
}
